export default "__VITE_ASSET__hGxoMBCX__"